import React from 'react';

import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import Button from '@material-ui/core/Button';
import SendIcon from '@material-ui/icons/Send';

import { useSnackbar } from 'notistack';

import useClient from 'components/Auth/useClient';
import useAppBar from 'components/AppBar/useAppBar';

import {
  sendEmailVerification,
} from 'firebase/auth';

import FirebaseAuthContext from 'components/Auth/FirebaseAuthContext';
import useFunctions from 'components/Auth/useFunctions';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(4),
  },
}));

export default function EmailVerifyAlert(props)
{
  const { enqueueSnackbar } = useSnackbar();

  const [processing, setProcessing] = React.useState(false);
  const functions = useFunctions();
  const auth = React.useContext(FirebaseAuthContext);
  const [stopper, setStopper] = React.useState(false);

  const reloadCurrentUser = React.useCallback(async () => {
    await auth.currentUser.reload();
    if (auth.currentUser.emailVerified)
    {
      functions.signIn(auth.currentUser);
    }
  }, [auth]);

  const client = useClient();
  const handleResend = React.useCallback(async () => {
    if (processing) return;
    if (!auth.currentUser) return;

    setProcessing(true);
    try
    {
      await reloadCurrentUser();
      await client.post(`api/user/sendVerificationLink`, { redirectUrl:window.location.href} )
        .then(user => {
          enqueueSnackbar('確認メールを再送しました。\nメールが届くまで数分かかる場合があります。', { whiteSpace: 'pre-line', variant: 'success' });
          setStopper(true);
        })
        .catch(error => {
          if (error.response.status == 409) {
            enqueueSnackbar('確認メール送信の頻度が高すぎます。時間をおいて再度実行してください。', { variant: 'error' });
          }
          else {
            enqueueSnackbar('確認メールの再送に失敗しました。', { variant: 'error' });
          }
        })
    }
    finally
    {
      setProcessing(false);
    }
  },[client, processing, auth]);

  React.useEffect(() => {
      window.addEventListener("focus", reloadCurrentUser);
      reloadCurrentUser();
      return () => {
          window.removeEventListener("focus", reloadCurrentUser);
      };
  }, [auth]);

  useAppBar();

  const classes = useStyles();
  return (
    <Grid className={classes.container} container justifyContent="center">
      <Paper className={classes.paper}>
        <Typography>アカウント登録時に送信された確認メールのURLから手続きを完了してください。</Typography>
        <Typography>確認が完了するまで、ドキュメントは閲覧できません。</Typography>
        <p></p>
        <center>
          <Button
            disabled={stopper}
            color="primary"
            variant="contained"
            onClick={handleResend}
            startIcon={<SendIcon />}>
            確認メールを再送信
          </Button>
        </center>
      </Paper>
    </Grid>
  )
}